import React, { FunctionComponent } from "react";

const NavigationMenuVerticalIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/interface-essential/menu/navigation-menu-vertical
  return (
    <svg viewBox="-0.25 -0.25 24.5 24.5" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.362 20.628 A2.625 2.625 0 1 0 14.612 20.628 A2.625 2.625 0 1 0 9.362 20.628 Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M9.362 3.378 A2.625 2.625 0 1 0 14.612 3.378 A2.625 2.625 0 1 0 9.362 3.378 Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M9.362 12.003 A2.625 2.625 0 1 0 14.612 12.003 A2.625 2.625 0 1 0 9.362 12.003 Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default NavigationMenuVerticalIcon;
